import { COLLABORATORS_SECTION_ID } from 'modules/planning/components/PeriodWizard/steps/sections'

export const createCollaboratorsWizardStep = (translations: {
  collaboratorsStepTitle: () => string
  collaboratorsStepDescription: () => string
  previous: () => string
  finish: () => string
}) => ({
  title: translations.collaboratorsStepTitle(),
  description: translations.collaboratorsStepDescription(),
  nextLabel: translations.finish(),
  previousLabel: translations.previous(),
  sectionIds: [COLLABORATORS_SECTION_ID],
})
